import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'

export const taskTooltipFragment = gql`
  fragment taskTooltipFragment on Task {
    _id
    name
    code
    status
    startDate
    endDate
    timeSpent
    percentageComplete
    tags
    description
    members {
      _id
      profile {
        _id
        name
        picture
        email
      }
    }
    project {
      _id
      code
    }
    workOrder {
      _id
      code
    }
    subTasks {
      _id
      name
      status
    }
    parentTask {
      _id
    }
  }
`

export const taskTooltipQueries = buildGraphqlQuery('Task', taskTooltipFragment)
